import { css } from '@emotion/react'
import PencilIcon from '@mui/icons-material/CreateOutlined'
import FileIcon from '@mui/icons-material/DescriptionOutlined'
import { Tooltip } from '@mui/material'
import { SubmissionTrigger } from '@global/types'
import { t } from '@lingui/core/macro'

const marginRight = css`
  margin-right: 8px;
`

interface Props {
  trigger: SubmissionTrigger
}

export const Trigger = ({ trigger }: Props) => {
  switch (trigger) {
    case SubmissionTrigger.FILE_BASED_OVERWRITE: {
      return (
        <Tooltip title={t`Started by file based overwrite`}>
          <FileIcon css={marginRight} fontSize="small" />
        </Tooltip>
      )
    }
    case SubmissionTrigger.MANUAL_RESUBMISSION: {
      return (
        <Tooltip title={t`Started by manual edit`}>
          <PencilIcon css={marginRight} fontSize="small" />
        </Tooltip>
      )
    }
    default:
      return null
  }
}
